<template>
  <div class="contain">
    <!-- 第一部分 -->
    <el-card class="box-card card-a">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 40px" class="tab1">客户信息</div>
      </div>
      <div>
        <el-row>
          <el-col :span="6">
            <div class="choose">
              <el-input v-model="input" placeholder="请输入内容"></el-input>
              <el-button type="primary" style="margin-left: 20px; height: 40px" @click="openDialog">选择</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="cunstomInfo">
        <el-row>
          <el-col :span="8">
            客户姓名：<span style="color: red">{{
              checkList[0].customerName
            }}</span>
          </el-col>
          <el-col :span="8">联系人：<span style="color: red">
              {{ checkList[0].contact }}</span></el-col>
          <el-col :span="8">联系号码：{{ checkList[0].phone }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" style="display:flex; align-items:center">
            客户联系地址：
            <span class="cusAdress">{{ checkList[0].address }}</span>
          </el-col>
          <el-col :span="8">税号：{{ checkList[0].dutyNo }} </el-col>
          <el-col :span="8">商务负责人：{{ checkList[0].businessDirectorName }}</el-col>
        </el-row>
      </div>
      <div class="saveBtn">
        <el-button type="primary" style="width: 200px; height: 40px" @click="save">保存</el-button>
      </div>
    </el-card>
    <!-- 第二部分 -->
    <el-card class="box-card card-b">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 40px" :class="cardTwo == 'one' ? 'tab1' : 'tab'" @click="changeTab('one')">
          合同信息
        </div>
        <div style="height: 40px" :class="cardTwo == 'two' ? 'tab1' : 'tab'" @click="changeTab('two')">
          上传合同附件
        </div>
      </div>
      <div v-if="cardTwo == 'one'">
        <el-form ref="form" :model="form" label-width="150px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="项目名称：">
                <el-input placeholder="请输入项目名称" v-model="projectName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="合同编号：">
                <el-input placeholder="请输入合同编号" v-model="projectNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="合同金额：">
                <el-input placeholder="输入合同金额（元）" v-model="projectAmount" type="number"
                  @input="projectAmountInput"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工期：">
                <el-input placeholder="请输入工期" v-model="pprojectTime"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-for="(step, i) in stepsList" :key="i">
            <el-col :span="8">
              <el-form-item :label="i === 0 ? '节点名称：' : ''">
                <!-- <el-input placeholder="一期"></el-input> -->

                <div>
                  <div class="memberBox">
                    <el-input placeholder="节点名称" v-model="step.paymentName"></el-input>
                    <i class="el-icon-circle-plus-outline addIcon" @click="addMember" v-if="i === 0"></i>
                    <i class="el-icon-remove-outline addIcon" @click="deleteMember(i)" v-if="i > 0"></i>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="i === 0 ? '工期节点：' : ''">
                <el-date-picker v-model="step.paymentTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="结项日期：">
                <el-date-picker v-model="conclusionTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="居间费：">
                <el-input placeholder="请输入居间费" v-model="totalInteFee" type="number"
                  @input="totalInteFeeInput"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="备注：">
                <el-input type="textarea" :rows="6" placeholder="请输入备注" v-model="remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="节点附件：">
                <div class="uploadBBox">
                  <div class="uploadBox">
                    <el-upload class="avatar-uploader" :action="$uploadURL" accept="image/jpeg,image/jpg,image/png"
                      :show-file-list="false" :on-success="handleContractCover" :before-upload="beforeAvatarUpload">
                      <img v-if="contractCover" :src="contractCover" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p>{{ contractCoverName }}</p>
                    <p>上传合同封面</p>
                  </div>
                  <div class="uploadBox">
                    <el-upload class="avatar-uploader" :action="$uploadURL" accept="image/jpeg,image/jpg,image/png"
                      :show-file-list="false" :on-success="handleContractTime" :before-upload="beforeAvatarUpload">
                      <img v-if="contractTime" :src="contractTime" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p>{{ contractTimeName }}</p>
                    <p>上传工期</p>
                  </div>
                  <div class="uploadBox">
                    <el-upload class="avatar-uploader" :action="$uploadURL" accept="image/jpeg,image/jpg,image/png"
                      :show-file-list="false" :on-success="handleContractClearingType"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="contractClearingType" :src="contractClearingType" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p>{{ contractTypeName }}</p>
                    <p>上传结算方式</p>
                  </div>
                  <div class="uploadBox">
                    <el-upload class="avatar-uploader" :action="$uploadURL" accept="image/jpeg,image/jpg,image/png"
                      :show-file-list="false" :on-success="handleContractInscribe" :before-upload="beforeAvatarUpload">
                      <img v-if="contractInscribe" :src="contractInscribe" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p>{{ contractInscribeName }}</p>
                    <p>上传合同落款</p>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-if="cardTwo == 'two'">
        <el-row>
          <el-col :span="16">
            <div class="uploadBBox" style="margin-left: 100px">
              <div class="uploadBox">
                <el-upload class="avatar-uploader" :action="$uploadURL" accept="image/jpeg,image/jpg,image/png"
                  :show-file-list="false" :on-success="handleOriginaContract" :before-upload="beforeAvatarUpload">
                  <img v-if="originaContract" :src="originaContract" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p>{{ originaContractName }}</p>
                <p>上传原始合同</p>
              </div>
              <div class="uploadBox">
                <el-upload class="avatar-uploader" :action="$uploadURL" accept="image/jpeg,image/jpg,image/png"
                  :show-file-list="false" :on-success="handleContractSubsOne" :before-upload="beforeAvatarUpload">
                  <img v-if="contractSubsOne" :src="contractSubsOne" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p>{{ contractSubsOneName }}</p>
                <p>上传合同附件</p>
              </div>
              <div class="uploadBox">
                <el-upload class="avatar-uploader" accept="image/jpeg,image/jpg,image/png" :action="$uploadURL"
                  :show-file-list="false" :on-success="handleContractSubsTwo" :before-upload="beforeAvatarUpload">
                  <img v-if="contractSubsTwo" :src="contractSubsTwo" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p>{{ contractSubsTwoName }}</p>
                <p>上传合同附件</p>
              </div>
              <div class="uploadBox">
                <el-upload class="avatar-uploader" accept="image/jpeg,image/jpg,image/png" :action="$uploadURL"
                  :show-file-list="false" :on-success="handleContractSubsThree" :before-upload="beforeAvatarUpload">
                  <img v-if="contractSubsThree" :src="contractSubsThree" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p>{{ contractSubsThreeName }}</p>
                <p>上传合同附件</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 第三部分 -->
    <el-card class="box-card card-b">
      <div slot="header" class="clearfix" style="display: flex">
        <div style="height: 40px" class="tab1">上传一期款付款凭证</div>
      </div>
      <div>
        <el-form ref="form" :model="formA" label-width="150px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="付款方式：">
                <el-select v-model="payType" placeholder="请选择付款方式">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="付款金额：">
                <el-input placeholder="请输入付款金额" v-model="payAmount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="备注：">
                <el-input type="textarea" :rows="6" placeholder="请输入备注" v-model="payRemark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="付款截图：">
                <div class="uploadBBox">
                  <div class="uploadBox">
                    <el-upload class="avatar-uploader" accept="image/jpeg,image/jpg,image/png" :action="$uploadURL"
                      :show-file-list="false" :on-success="handlepaymentOne" :before-upload="beforeAvatarUpload">
                      <img v-if="paymentfileOne" :src="paymentfileOne" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p>{{ paymentfileNameOne }}</p>
                    <p>上传付款截图</p>
                  </div>
                  <div class="uploadBox">
                    <el-upload class="avatar-uploader" accept="image/jpeg,image/jpg,image/png" :action="$uploadURL"
                      :show-file-list="false" :on-success="handlepaymentTwo" :before-upload="beforeAvatarUpload">
                      <img v-if="paymentfileTwo" :src="paymentfileTwo" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p>{{ paymentfileNameTwo }}</p>
                    <p>上传付款截图</p>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 选择客户弹窗 -->
    <el-dialog title="选择人员" :visible.sync="dialogVisible" width="50%">
      <el-form ref="form" :model="searchInput" label-width="5rem">
        <div style="padding: 1.25rem">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="手机号">
                <el-input v-model="searchInput.projectName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户姓名">
                <el-input v-model="searchInput.customerName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="success" @click="search">查询</el-button>
            </el-col>
          </el-row>

          <div class="listBox">
            <el-scrollbar style="height: 100%; width: 100%">
              <el-table :data="tableData" style="width: 100%" @row-click="singleElection" highlight-current-row border
                height="330">
                <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">&nbsp;</el-radio>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="客户姓名">
                  <template slot-scope="scope">
                    <span>{{ scope.row.customerName }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="联系人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.contact }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="联系号码">
                  <template slot-scope="scope">
                    <span>{{ scope.row.phone }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="商务负责人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.businessDirectorName }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.currPage" :page-sizes="[200, 10, 20, 30, 50]"
                :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
            </el-scrollbar>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">选 择</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardTwo: "one",
      formA: {},
      options: [
        {
          value: "1",
          label: "微信",
        },
        {
          value: "2",
          label: "支付宝",
        },
        {
          value: "3",
          label: "对公打款",
        },
        {
          value: "4",
          label: "银行卡",
        },
      ],
      tableData: [
        {
          id: "0001",
          projectName: "佰草园",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0002",
          projectName: "佰草园1",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0003",
          projectName: "佰草园2",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
        {
          id: "0004",
          projectName: "佰草园3",
          name: "王小虎",
          startTime: "2016-05-02",
          endTime: "2016-05-02",
          duration: 80,
        },
      ],
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [
        {
          customerName: "",
          contact: "",
          phone: "",
          address: "",
          dutyNo: "",
          businessDirectorName: "",
        },
      ],
      form: {},
      dialogVisible: false,
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 200,
        //查询条件
        condition: {
          id: "",
          customerName: "",
          phone: "",
          userCode: "",
        },
      },
      total: 0,
      input: "",
      searchInput: {},
      // 合同封面图
      contractCover: "",
      contractCoverName: "",
      // 工期图
      contractTime: "",
      contractTimeName: "",
      // 结算方式
      contractClearingType: "",
      contractTypeName: "",
      // 合同落款
      contractInscribe: "",
      contractInscribeName: "",
      // 原始合同
      originaContract: "",
      originaContractName: "",
      // 合同附件
      contractSubsOne: "",
      contractSubsOneName: "",
      contractSubsTwo: "",
      contractSubsTwoName: "",
      contractSubsThree: "",
      contractSubsThreeName: "",
      // 付款截图
      paymentfileOne: "",
      paymentfileNameOne: "",
      paymentfileTwo: "",
      paymentfileNameTwo: "",
      stepsList: [
        {
          paymentName: "一期",
          paymentTime: "",
        },
      ],
      // 输入框绑定的参数
      payRemark: "",
      payAmount: "",
      payType: "",
      remark: "",
      totalInteFee: "",
      conclusionTime: "",
      pprojectTime: "",
      projectAmount: "",
      projectNo: "",
      projectName: "",
    };
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.customerName = this.searchInput.customerName;
      this.queryInfo.condition.phone = this.searchInput.phone;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    changeTab(type) {
      this.cardTwo = type;
    },
    openDialog() {
      this.dialogVisible = true;
    },
    getListData() {
      this.queryInfo.condition.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      this.$http.post("/customer/list", this.queryInfo).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.total = res.data.data.count;
          this.queryInfo.currPage = res.data.data.currPage;
          this.tableData = res.data.data.data;
        } else {
          this.$notify.error({
            title: "提示",
            message: res.data.message,
            showClose: true,
          });
        }
      });
    },
    // 选择客户
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = this.tableData.filter((item) => item.id === row.id);
      console.log(`该行的id为${row.id}`, this.checkList);
    },
    // 提交保存
    save() {
      const { customerCode } = this.checkList[0];
      var sendData = {};
      sendData.projectName = this.projectName;
      sendData.projectNo = this.projectNo;
      sendData.projectAmount = this.projectAmount;
      sendData.pprojectTime = this.pprojectTime;
      sendData.projectPayments = this.stepsList;
      sendData.conclusionTime = this.conclusionTime;
      sendData.totalInteFee = this.totalInteFee;
      sendData.remark = this.remark;
      sendData.contractCover = this.contractCover;
      sendData.contractTime = this.contractTime;
      sendData.contractClearingType = this.contractClearingType;
      sendData.contractInscribe = this.contractInscribe;
      sendData.originaContract = this.originaContract;
      sendData.payType = this.payType;
      sendData.payAmount = this.payAmount;
      sendData.payRemark = this.payRemark;
      sendData.customerCode = customerCode;
      sendData.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      sendData.businessDirectorName = localStorage.getItem("name");
      // 合同附件
      let contractSubsList = [];
      if (this.contractSubsOne) {
        contractSubsList.push(this.contractSubsOne);
      }
      if (this.contractSubsTwo) {
        contractSubsList.push(this.contractSubsTwo);
      }
      if (this.contractSubsThree) {
        contractSubsList.push(this.contractSubsThree);
      }
      sendData.originaContractSubs = contractSubsList;
      // 付款截图
      let paymentfileList = [];
      if (this.paymentfileOne) {
        paymentfileList.push(this.paymentfileOne);
      }
      if (this.paymentfileTwo) {
        paymentfileList.push(this.paymentfileTwo);
      }
      sendData.paymentScreenshots = paymentfileList;

      console.log("sendData", sendData);

      this.$http.post("/project/projectApproval", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
            title: "提示",
            message: "保存成功",
            showClose: true,
          });
          this.$router.go(0);
        } else {
          this.$notify.error({
            title: "提示",
            message: res.data.message,
            showClose: true,
          });
        }
      });
    },
    // 合同封面
    handleContractCover(res, file, fileList) {
      console.log(res, file, fileList);
      this.contractCover = res.data.url;
      this.contractCoverName = file.name;
    },
    // 工期图片
    handleContractTime(res, file, fileList) {
      this.contractTime = res.data.url;
      this.contractTimeName = file.name;
    },
    // 结算方式
    handleContractClearingType(res, file, fileList) {
      this.contractClearingType = res.data.url;
      this.contractTypeName = file.name;
    },
    // 上传合同落款
    handleContractInscribe(res, file, fileList) {
      this.contractInscribe = res.data.url;
      this.contractInscribeName = file.name;
    },
    // 上传原始合同
    handleOriginaContract(res, file, fileList) {
      this.originaContract = res.data.url;
      this.originaContractName = file.name;
    },
    // 上传合同附件
    handleContractSubsOne(res, file, fileList) {
      this.contractSubsOne = res.data.url;
      this.contractSubsOneName = file.name;
    },
    handleContractSubsTwo(res, file, fileList) {
      this.contractSubsTwo = res.data.url;
      this.contractSubsTwoName = file.name;
    },
    handleContractSubsThree(res, file, fileList) {
      this.contractSubsThree = res.data.url;
      this.contractSubsThreeName = file.name;
    },
    // 上传付款截图
    handlepaymentOne(res, file, fileList) {
      this.paymentfileOne = res.data.url;
      this.paymentfileNameOne = file.name;
    },
    handlepaymentTwo(res, file, fileList) {
      this.paymentfileTwo = res.data.url;
      this.paymentfileNameTwo = file.name;
    },
    // 添加节点
    addMember() {
      this.stepsList.push({
        paymentName: "",
        paymentTime: "",
      });
    },
    // 删除节点
    deleteMember(i) {
      this.stepsList.splice(i, 1);
    },

    beforeAvatarUpload() { },
    //合同金额输入时
    projectAmountInput(val) {
      if (val < 0) {
        this.projectAmount = ''
      }
    },
    //居间费输入时
    totalInteFeeInput(val) {
      if (val < 0) {
        this.totalInteFee = ''
      }
    }
  },
  created() {
    this.queryInfo.pageSize = this.$pageSize;
    let myDate = new Date();
    let y = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
    let m = myDate.getMonth(); //获取当前月份(0-11,0代表1月)
    let d = myDate.getDate(); //获取当前日(1-31)
    this.stepsList[0].paymentTime = y + "-" + (m + 1) + "-" + d;
    this.getListData();
  },
};
</script>

<style lang="less" scoped>
.contain {
  padding: 10px 20px;
  box-sizing: border-box;

  /deep/.el-card__header {
    padding: 0;
    border-bottom: 1px solid #409eff;
  }

  .card-a {
    .choose {
      display: flex;

      /deep/.el-input__inner {
        height: 40px !important;
        line-height: 40px !important;
      }
    }

    .cunstomInfo {
      margin: 20px 0;
      background-color: #f7f7f7;
      padding: 20px 30px;
      box-sizing: border-box;
      line-height: 40px;

      .cusAdress {
        display: inline-block;
        width: 200px;
        /* 关键代码 */
        text-overflow: ellipsis;
        /* 溢出显示省略号 */
        overflow: hidden;
        /* 溢出隐藏 */
        white-space: nowrap;
        /* 强制不换行 */
      }
    }

    .saveBtn {
      text-align: center;
    }

    .tab1 {
      border: 1px solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }
  }

  .card-b {
    margin-top: 20px;

    .tab {
      border: 1px solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
      color: #409eff;
    }

    .tab1 {
      border: 1px solid #409eff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
      color: #fff;
      background-color: #409eff;
    }

    .uploadBBox {
      display: flex;
      justify-content: space-between;

      .uploadBox {
        text-align: center;
      }
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
      border: 1px solid #efefef;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }

  .listBox {
    height: 400px;
  }

  .memberBox {
    position: relative;

    .addIcon {
      position: absolute;
      top: 8px;
      margin-left: 10px;
      font-size: 18px;
      color: #409eff;
    }
  }

  /deep/.el-button {
    border-radius: 0;
  }

  // /deep/.el-scrollbar__view {
  //   min-width: 100%;
  // }
  // /deep/.el-scrollbar__wrap {
  //   overflow-x: auto;
  //   height: calc(100%); //多出来的20px是横向滚动条默认的样式
  //   width: 100%;
  //   color: #fff;
  // }
  // /deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  //   white-space: nowrap;
  //   display: inline-block;
  // }
  /deep/.el-dialog__header {
    background-color: #fff;
    padding: 0.625rem;
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
    border-bottom: 0.0625rem solid #efefef;
  }

  /deep/.el-dialog__header .el-dialog__title {
    line-height: 1.25rem;
    font-size: 1rem;
    color: #000;
  }
}

/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
